import { Discount, Subtotal, TotalDue, VATTax } from "../../../../utils/Constant";

const InvoiceTableTotal = ({ data }: any) => {
  // If no items, return null to render nothing
  if (!data?.invoiceItems?.length) {
    return null;
  }

  // Calculate totals dynamically based on invoiceItems
  const subtotal = data.invoiceItems.reduce((sum: number, item: any) => sum + Number(item.total), 0);
  const vatTax = 50.00; 
  const discount = 30.00; 
  const totalDue = subtotal + vatTax - discount;

  return (
    <>
      <tr style={{background: "#F5F6F9"}}>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style={{ textAlign: "center" }}>
          <span style={{ opacity: "0.8", fontWeight: 600 }}>{Subtotal}</span>
        </td>
        <td style={{ textAlign: "center", background: "#F5F6F9", display: "block" }}>
          <span style={{ color: "#6BC6AF", fontWeight: 600, opacity: "0.9" }}>
            ${subtotal.toFixed(2)}
          </span>
        </td>
      </tr>
      <tr style={{background: "#F5F6F9"}}>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style={{ width: "12%", textAlign: "center" }}>
          <span style={{ opacity: "0.8", fontWeight: 600 }}>{VATTax}</span>
        </td>
        <td style={{ textAlign: "center", background: "#F5F6F9", display: "block" }}>
          <span style={{ color: "#6BC6AF", fontWeight: 600, opacity: "0.9" }}>
            ${vatTax.toFixed(2)}
          </span>
        </td>
      </tr>
      <tr style={{background: "#F5F6F9"}}>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style={{ width: "12%", textAlign: "center" }}>
          <span style={{ opacity: "0.8", fontWeight: 600 }}>{Discount}</span>
        </td>
        <td style={{ textAlign: "center", background: "#F5F6F9", display: "block" }}>
          <span style={{ color: "#6BC6AF", opacity: "0.9", fontWeight: 600 }}>
            ${discount.toFixed(2)}
          </span>
        </td>
      </tr>
      <tr style={{background: "#F5F6F9"}}>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style={{ width: "12%", textAlign: "center" }}>
          <span style={{ opacity: "0.8", fontWeight: 600 }}>{TotalDue}</span>
        </td>
        <td style={{ textAlign: "center", background: "#F5F6F9" }}>
          <span
            style={{
              color: "#ffffff",
              fontWeight: 600,
              opacity: "0.9",
              background: "#FF914D",
              padding: "12px 37px",
              marginTop: 0,
              display: "block",
            }}
          >
            ${totalDue.toFixed(2)}
          </span>
        </td>
      </tr>
    </>
  );
};

export default InvoiceTableTotal;